import { render, staticRenderFns } from "./preferential.vue?vue&type=template&id=0ecfa2de&"
import script from "./preferential.vue?vue&type=script&lang=ts&"
export * from "./preferential.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "preferential.vue"
export default component.exports